import React from "react";
import { gql, useQuery } from "@apollo/client";
import { Bar } from "react-chartjs-2";

import Layout from "components/common/Layout";

const LINE_STYLES = [
  {
    backgroundColor: "rgba(241, 133, 0, .2)",
    borderColor: "rgba(241, 133, 0, 1)",
    borderWidth: 1,
  },
  {
    backgroundColor: "rgba(196, 0, 82, .2)",
    borderColor: "rgba(196, 0, 82, 1)",
    borderWidth: 1,
  },
  {
    backgroundColor: "rgba(0, 42, 230, .2)",
    borderColor: "rgba(0, 42, 230, 1)",
    borderWidth: 1,
  },
  {
    backgroundColor: "rgba(35, 31, 32, .2)",
    borderColor: "rgba(35, 31, 32, 1)",
    borderWidth: 1,
  },
];

export default function StatsChart({ query, variables, ...props }) {
  const { data, loading } = useQuery(query, {
    variables,
    fetchPolicy: "network-only",
  });

  if (loading) return <Layout.Loading />;
  if (!data?.statistics.stat) return null;

  const chartData = {
    labels: [...data.statistics.stat.labels],
    datasets: data.statistics.stat.datasets.map((dataset, idx) => ({
      ...LINE_STYLES[idx % LINE_STYLES.length],
      ...dataset,
    })),
  };

  return <Bar data={chartData} redraw {...props} />;
}

StatsChart.fragments = {
  statistic: gql`
    fragment StatsChart_statistic on Statistic {
      labels
      datasets {
        label
        stack
        data
      }
    }
  `,
};
